import React from 'react';
import { Sparkles, Clock, Palette, TrendingUp, Settings, Shield } from 'lucide-react';
import { mockData } from '../mock';

const iconMap = [
  Sparkles,
  Clock,
  Palette,
  TrendingUp,
  Settings,
  Shield,
];

export const Benefits = () => {
  const { benefits } = mockData;

  return (
    <section className="py-20 lg:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-12 md:mb-16">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 mb-3 md:mb-4 tracking-tight">
            {benefits.title}
          </h2>
          <p className="text-base md:text-lg text-gray-600">{benefits.subtitle}</p>
        </div>

        {/* Benefits Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {benefits.items.map((benefit, index) => {
            const Icon = iconMap[index];
            return (
              <div
                key={benefit.id}
                className="group p-5 md:p-8 rounded-2xl bg-gradient-to-br from-gray-50 to-white border border-gray-100 hover:border-[#2AD7C5]/30 hover:shadow-lg transition-all duration-300 hover:-translate-y-1"
              >
                {/* Icon */}
                <div className="mb-4 md:mb-5">
                  <div className="w-10 h-10 md:w-12 md:h-12 bg-[#2AD7C5]/10 rounded-lg flex items-center justify-center group-hover:bg-[#2AD7C5]/20 transition-colors duration-300">
                    <Icon className="text-[#2AD7C5]" size={20} />
                  </div>
                </div>

                {/* Content */}
                <h3 className="text-base md:text-lg font-semibold text-gray-900 mb-2 md:mb-3 leading-tight">
                  {benefit.title}
                </h3>
                <p className="text-sm md:text-base text-gray-600 leading-relaxed">
                  {benefit.description}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
